import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle, Settings, Calculator } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#193B7F' }}>
            {t.services.title}
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Process Consulting */}
          <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="flex items-start space-x-4 mb-6">
              <div
                className="flex-shrink-0 w-16 h-16 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: '#193B7F' }}
              >
                <Settings className="h-8 w-8 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2" style={{ color: '#193B7F' }}>
                  {t.services.processes.title}
                </h3>
              </div>
            </div>

            <p className="text-gray-600 mb-6 leading-relaxed">
              {t.services.processes.description}
            </p>

            <div className="space-y-3">
              {t.services.processes.items.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#45C1E0' }} />
                  <span className="text-gray-700 text-sm">{item}</span>
                </div>
              ))}
            </div>

            {/* Image */}
            <div className="mt-6 rounded-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1758518729794-456bbd9f70f8?w=600&q=80"
                alt="Process consulting"
                className="w-full h-40 object-cover"
              />
            </div>
          </div>

          {/* Costs Consulting */}
          <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="flex items-start space-x-4 mb-6">
              <div
                className="flex-shrink-0 w-16 h-16 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: '#45C1E0' }}
              >
                <Calculator className="h-8 w-8 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2" style={{ color: '#193B7F' }}>
                  {t.services.costs.title}
                </h3>
              </div>
            </div>

            <p className="text-gray-600 mb-6 leading-relaxed">
              {t.services.costs.description}
            </p>

            <div className="space-y-3">
              {t.services.costs.items.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#45C1E0' }} />
                  <span className="text-gray-700 text-sm">{item}</span>
                </div>
              ))}
            </div>

            {/* Image */}
            <div className="mt-6 rounded-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80"
                alt="Cost management"
                className="w-full h-40 object-cover"
              />
            </div>
          </div>

          {/* Pricing Consulting */}
          <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="flex items-start space-x-4 mb-6">
              <div
                className="flex-shrink-0 w-16 h-16 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: '#193B7F' }}
              >
                <Calculator className="h-8 w-8 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2" style={{ color: '#193B7F' }}>
                  {t.services.pricing.title}
                </h3>
              </div>
            </div>

            <p className="text-gray-600 mb-6 leading-relaxed">
              {t.services.pricing.description}
            </p>

            <div className="space-y-3">
              {t.services.pricing.items.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#45C1E0' }} />
                  <span className="text-gray-700 text-sm">{item}</span>
                </div>
              ))}
            </div>

            {/* Image */}
            <div className="mt-6 rounded-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1758518731457-5ef826b75b3b?w=600&q=80"
                alt="Pricing strategy"
                className="w-full h-40 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
